import { Chip } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import { ICustomTheme } from 'interfaces';

export const StyledChip = styled(Chip)(
  ({ isMobile, theme }: { isMobile: boolean; theme: ICustomTheme }) => ({
    borderRadius: theme.spacing(5),
    width: isMobile ? 'auto' : theme.spacing(20),
    height: isMobile ? theme.spacing(6) : theme.spacing(7),
    padding: theme.spacing(0.5),
    backgroundColor: theme.colors.paletteFromBO.secondary,
  }),
);

export const StyledLabelContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    color: 'white',
    width: '100%',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  }),
);

export const StyledLabelText = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    paddingLeft: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    color: 'white',
    flexWrap: 'wrap',
  }),
);
